export default __webpack_public_path__ + "static/media/pic44.e59ca6bb.jpg";